module.exports = __webpack_public_path__ + "static/media/me.dac50c9e.jpg";